import React from 'react';
import { db } from './Firebase';

const Edit = ({ id, item, setEdit }) => {

    // modify food
    function modifyFood(e) {
        e.preventDefault();

        const editForm = document.getElementById('editForm');
        const newData = {            
            name: editForm.name.value,
            price: editForm.price.value,
            photo: item.photo
        }

        // updating document
        db.collection('items').doc(id).update(newData)
        .then(() => setEdit(null));
    }

    return (
        <form id="editForm" className="p-4" onSubmit={modifyFood}>
            <input type="name" defaultValue={item.name} className="my-2 form-control form-control-sm my-0" name="name" required />
            <input defaultValue={item.price} type="number" min="0" className="my-2 form-control form-control-sm my-0" name="price" required />
            <button type="submit" className="text-white btn mx-2 my-1 btn-one">Update</button>
            <button onClick={() => setEdit(null)} className="btn mx-2 my-1 btn-primary">Cancel</button>
        </form>
    );
};

export default Edit;